import styled from '@emotion/styled';
import { Table } from '@innovationdepartment/proxima-ui';
import type { BrandProductsViewProps } from './types';

const BrandProductsTableWrapper = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  * th {
    position: sticky;
    top: 0;
    background: white;
    z-index: 1;
  }
`;

const BrandProductsTable = (props: BrandProductsViewProps) => {
  const { products, tableConfig, tableRef } = props;

  return (
    <BrandProductsTableWrapper>
      <Table tableWrapperRef={tableRef} data={products} config={tableConfig} variant="celes" />
    </BrandProductsTableWrapper>
  );
};

export default BrandProductsTable;
